import { tokenExpires, tokenKey } from "../settings";
import { Local } from "@/utils/storage";
class User {
    static TOKEN_KEY = tokenKey;
    static LAST_AUTH = "LAST_AUTH_DEEPBERRY_CMS";
    static DEFAULT_PANEL = "cms";
    constructor() {
        this.TOKEN_KEY = tokenKey;
        this.LAST_AUTH = "LAST_AUTH_DEEPBERRY_CMS";
        this.DEFAULT_PANEL = "cms";
        this.profile = {};

        this.anonymous = {
            id: 0,
            username: "anonymous",
            nickname: "匿名用户",
            avatar: "",
            group: 1,
            panel: User.DEFAULT_PANEL,
        };
        // token有效期30天
        this.expires = tokenExpires;
        this.created_at = 0;

        // 登录状态
        this.logged_in = false;
    }

    // 检查当前状态
    check() {
        if (this.isLogin()) {
            this.profile.id = localStorage && localStorage.getItem("uid");
            this.profile.group = (localStorage && localStorage.getItem("group")) || 1;
            this.profile.token = localStorage && localStorage.getItem("token");
            this.profile.username = localStorage && localStorage.getItem("username");
            this.profile.status = localStorage && localStorage.getItem("status");
            this.profile.panel = (localStorage && localStorage.getItem("panel")) || User.DEFAULT_PANEL;
        } else {
            this.profile = this.anonymous;
        }
        return this;
    }

    /**
     * 更新用户信息
     * @param {Object} data 用户信息
     * @memberof User
     */
    update(data) {
        return new Promise((resolve, reject) => {
            try {
                this._save(data);
                resolve(data);
            } catch (error) {
                //如果localStorage不存在或已满
                if (localStorage) {
                    localStorage.clear();
                    this._save(data);
                    resolve(this);
                } else {
                    reject(new Error("localStorage不可用"));
                }
            }
        });
    }

    /**
     * 保存用户信息到本地
     * @param {Object} data 用户信息
     * @memberof User
     */
    _save(data) {
        this.userData = data;
        localStorage.setItem(User.TOKEN_KEY, data.token);
        localStorage.setItem(User.LAST_AUTH, Date.now());
        localStorage.setItem("logged_in", "true");
        localStorage.setItem("uid", data.id);
        localStorage.setItem("group", data.group);
        localStorage.setItem("username", data.username);
        localStorage.setItem("status", data.status);
        localStorage.setItem("avatar", data.avatar);
        localStorage.setItem("panel", data.panel || User.DEFAULT_PANEL);
    }

    /**
     * 注销
     * @memberof User
     */
    logout() {
        localStorage.clear();
        sessionStorage.clear();
    }

    /**
     * 获取令牌
     * @returns {String} 令牌
     * @memberof User
     */
    getToken() {
        return localStorage.getItem(User.TOKEN_KEY);
    }

    // 获取用户基础缓存信息
    getInfo() {
        this.check();
        return this.profile;
    }

    /**
     * 是否已登录
     * @returns {Boolean} 是否已登录
     * @memberof User
     */
    isLogin() {
        this.created_at = !localStorage.getItem(User.LAST_AUTH) ? -Infinity : parseInt(localStorage.getItem(User.LAST_AUTH));
        this.logged_in = localStorage.getItem("logged_in") == "true" ? true : false;
        this.panel = localStorage.getItem("panel");
        return this.logged_in && Date.now() - this.created_at < this.expires && this.panel;
    }

    /**
     * 前往登录
     * @param {String} redirect 登录后跳转的地址
     * @memberof User
     */
    toLogin(redirect) {
        redirect = redirect ? encodeURIComponent(redirect) : encodeURIComponent(location.href);
        location.href = "/?redirect=" + redirect;
    }

    // 登录完成跳转
    redirect(url) {
        console.log("redirect", url);
        const panel = this.getInfo().panel;
        const path = url || `/${panel}`;
        location.href = decodeURIComponent(path);
    }

    /**
     * 更新指定缓存字段
     *
     * @param {String} key 缓存字段
     * @param {String} value 缓存值
     * @returns {*}
     * @memberof User
     */
    updateCache(key, value) {
        return localStorage.setItem(key, value);
    }

    // 判断是否为普通成员
    isEditor() {
        return this.getInfo().group >= 64;
    }

    // 判断是否为管理员
    isAdmin() {
        return this.getInfo().group >= 128;
    }

    // 判断是否为超管
    isSuperAdmin() {
        return this.getInfo().group >= 512;
    }

    // 获取我的group
    getGroup() {
        return this.getInfo().group;
    }

    // 获取我的权限
    getPermission() {
        return Local.get("permission");
    }

    // 判断我的权限
    hasPermission(key) {
        const permission = this.getPermission().map((item) => item.action);
        return permission.includes(key);
    }

    // 设置多语言
    setLang(lang) {
        localStorage.setItem("lang", lang);
    }

    // 获取多语言
    getLang() {
        return localStorage.getItem("lang") || "zh-cn";
    }

    // 判断是否已过期
    isExpired() {
        this.created_at = !localStorage.getItem(User.LAST_AUTH) ? -Infinity : parseInt(localStorage.getItem(User.LAST_AUTH));
        return Date.now() - this.created_at >= this.expires;
    }

    // 注销缓存信息
    destroy() {
        localStorage.removeItem(User.TOKEN_KEY);
        localStorage.removeItem(User.LAST_AUTH);
        localStorage.removeItem("logged_in");
    }
}

export default new User();
